module.exports = __webpack_public_path__ + "static/img/tangyida.4185926.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tangyida.jpeg
// module id = 2YU7
// module chunks = 0